module.exports = __webpack_public_path__ + "6e1175b0dc9a3d79bcc096f1eb4ee6c2.svg";